import styles from "./styles/divider.module.scss";

export const Divider = (props: { width: number | string; margin?: number | string }) => {
  return (
    <>
      <div
        className={`${styles.divider} width:${props.width}`}
        style={{ marginTop: props.margin, marginBottom: props.margin }}
      ></div>
    </>
  );
};
